import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/poliol_logo_feher.webp")